<template>
  <div
    :id="content.idHTML"
    class="w-100 carte-promo"
    :class="[jel_getClassObject(content), isPromoActive ? 'd-flex' : 'd-none']"
    :style="{
      '--couleurDegrade': content.couleur,
    }"
  >
    <Carte :content="contentCarte">
      <div
        class="cursor-pointer carte d-flex h-100"
        :class="
          jel_isCarteLarge(content)
            ? { 'flex-row-reverse': content.positionnementTexteDesktop !== 'droite' }
            : 'flex-column'
        "
        @click="jel_forcerClickHyperlien(refRedirection)"
      >
        <b-link
          :ref="refRedirection"
          v-bind="jel_getLienBinding(content.lien)"
          class="d-none"
          @click.capture="gaPreventClick"
        >
          <!-- conserver pour accessibilité -->
          invisible
        </b-link>
        <div
          class="p-0 overflow-hidden flex-grow-1"
          :class="{ 'col-xl-6': jel_isCarteLarge(content) }"
        >
          <MediaImageX3
            :show="true"
            :content="contentMediaImageX3"
            :class="{ degrade: content.afficherDegrade == 'true' }"
          ></MediaImageX3>
        </div>
        <div class="p-0" :class="jel_isCarteLarge(content) ? 'd-lg-flex col-lg-6 ' : 'h-40'">
          <CarteInfoPrimairePromo
            :content="content"
            :class="
              jel_isCarteLarge(content)
                ? 'd-lg-flex align-items-lg-center w-lg-100'
                : 'h-100 info-primaire-promo-5x7'
            "
          ></CarteInfoPrimairePromo>
        </div>
      </div>
    </Carte>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment-timezone';
import { inEditor } from '@/helpers/AppHelpers';
import { gtmCustomEventByVendor } from '@/helpers/ConsentHelpers';
import Carte from '@/components/base/carte/Carte';
import CarteInfoPrimairePromo from '@/components/base/carte/CarteInfoPrimairePromo';
import MediaImageX3 from '@/components/media/image/MediaImageX3';

export default {
  name: 'CartePromo',
  components: {
    Carte,
    CarteInfoPrimairePromo,
    MediaImageX3,
  },
  props: {
    content: { type: Object, required: true },
  },
  data() {
    return {
      refRedirection: this._uid,
      cardIsArchived: false,
    };
  },
  computed: {
    ...mapGetters({
      getIsArchiveMode: 'menu/getIsArchiveMode',
    }),
    isPromoActive() {
      if (inEditor) {
        return true;
      }

      this.updateCardEndDate();
      const jelIsVisible = this.jel_isComponentVisible(this.content);

      if (jelIsVisible) {
        // mode archive et carte archivé on affiche la carte
        if (this.getIsArchiveMode && this.cardIsArchived) {
          return true;
        }

        // mode normal et carte active on affiche la carte
        if (!this.getIsArchiveMode && !this.cardIsArchived) {
          return true;
        }
      }
      return false;
    },

    contentMediaImageX3() {
      return {
        ...this.content,
        image: this.content.image || this.$store.state.produitCasino.imageDefaut,
        formatRatio: '1x1',
      };
    },
    contentCarte() {
      return {
        ...this.content,
        formatCarte: this.jel_isCarteLarge(this.content) ? '5x3' : '5x7',
      };
    },
  },
  methods: {
    updateCardEndDate() {
      const contentData = this.content;
      const maintenant = moment();
      const fin = this.content.dateFin
        ? moment(this.content.dateFin).tz('America/Montreal', true)
        : null;

      // vérifier si cette carte promo a une date de fin dans le passé pour le mode archive
      if (fin && fin.isBefore(maintenant)) {
        this.cardIsArchived = true;
        // ici on triche la date de fin pour permettre à la carte de s'afficher même si elle a une date de fin dans le passé
        // Sans ça, les cartes expirées ne s'afficheront pas dans les archives.
        contentData.dateFin = moment().add(1, 'd');
      }
    },

    gaPreventClick(event = null) {
      let position = null;
      const evt = 'ga-cp-click';
      const currentPath = window.location.pathname;
      let categorie = 'CP - Carte Promo';
      const emplacement = this.jel_gaGetEmplacement();
      const titrePromo = this.content.titre.replace('</br>', '<br>');
      const listeTitrePromo = document.getElementsByClassName('titre-promo');

      // Changement de catégorie pour Analytics dans la section promotions selon l'emplacement de la carte promo
      if (/fr\/promotion/i.test(currentPath) || /en\/promotion/i.test(currentPath)) {
        if (this.getIsArchiveMode) {
          // carte en mode archive
          categorie = 'Promotions - CP - C';
        } else {
          // carte promo actives
          categorie = 'Promotions - CP - B';

          if (document.getElementById('incontournables')) {
            const parent = document.getElementById('incontournables');
            if (parent.contains(this.$el)) {
              // carte promo active dans la section incontournables (le id incontournable doit être défini sur le row)
              categorie = 'Promotions - CP - A';
            }
          }
        }
      }

      for (let i = 0; i < listeTitrePromo.length; i++) {
        if (listeTitrePromo[i].innerHTML == titrePromo) {
          position = i + 1;
        }
      }
      const libelle = this.jel_libelleLienGoogleAnalytics(this.content.lien);
      if (libelle) {
        gtmCustomEventByVendor(process.env.VUE_APP_IAB_ID_ANALYTICS, {
          event: evt,
          categorie,
          emplacement,
          libelle,
          position,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.h-40 {
  height: 40%;
}
.degrade ::v-deep .degrade {
  content: '';
  bottom: 0;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 55%, var(--couleurDegrade) 95%);
  position: absolute;
  height: 100%;
  width: 100%;
}

.carte-promo {
  @supports (-webkit-touch-callout: none) and (not (translate: none)) {
    .carte {
      height: 50vh !important;
    }
  }
  @media not all and (min-resolution: 0.001dpcm) {
    @supports not (-webkit-touch-callout: none) {
      .carte {
        height: 80vh !important;
      }
    }
  }
}
</style>
